import { SVGProps } from './SVGProps';

const Facebook = ({ fill = 'white', width = '18', height = '18' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 320 512" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M80 299.3V512H196V299.3H282.5L300.5 201.5H196V166.9C196 115.2 216.3 95.4 268.7 95.4C285 95.4 298.1 95.8 305.7 96.6V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4V201.5H14V299.3H80Z"
        fill={fill}
      />
    </svg>
  );
};

export default Facebook;
